const cmsConfig = {
  vfoMultiSearchInputHint: ["请问有什么可以帮到您？", "我能为您提供什么帮助吗?"],
  vfoBotRestartChatLabel: "开始新的对话吧！",
  vfoWebServiceErrors: [
    {
      id: 1575614769750,
      assets: [],
      vfoDynamicAttributes: {},
      vfoWebServiceErrorMessage: "restart",
      vfoWebServiceErrorCode: 500,
      name: "Restart_Conversation",
      subtype: "WebServiceError",
      vfoIsFatalFormError: "true",
      vfoWebServiceException: "restart",
      vfoErrorMessageText: "对话已重置，<time> - 让我们重新聊聊吧！",
      type: "VFOConfiguration",
      quick_replies: [{}],
      text: "",
    },
    {
      id: 1542069189547,
      assets: [],
      vfoDynamicAttributes: {},
      vfoWebServiceErrorMessage: "inactivity",
      vfoWebServiceErrorCode: 500,
      name: "User_Inactivity",
      subtype: "WebServiceError",
      vfoIsFatalFormError: "true",
      vfoWebServiceException: "inactivity",
      vfoErrorMessageText: "因为您这边有一阵子没发消息，聊天已自动结束啦。很开心刚才很您聊天！",
      type: "VFOConfiguration",
      quick_replies: [{}],
      text: "",
    },
    {
      id: 1542069341545,
      assets: [],
      vfoDynamicAttributes: {},
      vfoWebServiceErrorMessage: "default",
      vfoWebServiceErrorCode: 500,
      name: "Default_BOT_ERROR",
      subtype: "WebServiceError",
      vfoIsFatalFormError: "true",
      vfoWebServiceException: "default",
      vfoErrorMessageText: "很开心和您聊天，感谢您的到来！",
      type: "VFOConfiguration",
      quick_replies: [{}],
      text: "",
    },
  ],
  urgentInfo: "",
  welcomeMessages: [
    "您好，您现在已连接人工客服，本次对话可能会使用翻译系统处理。",
    "我们会收集您的信息，用于身份验证及协助处理您的咨询。详情请参阅我们的<a href='https://one.nz/legal/policy/privacy/'>《隐私政策》</a>和<a href='https://one.nz/legal/terms-conditions/ai-assistant-agent/'>《条款与条件》</a>",
    "请问我能为您提供什么帮助？",
  ],
};

export default cmsConfig;
